export function Divider() {
  return <hr className="border-t-2 border-gray-100 my-4" />;
}
